export default __webpack_public_path__ + "static/media/empty_box.f2636a99.png";